<gstar-internal-users-grid
  [source]="entities()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)"
  (deleteRequested)="onDeleteUserRequested($event)" />
